import { Helmet } from 'react-helmet';

export default function FAQSchema({ items = [] }) {
  if (!items.length) return null;
  const data = {
    "@context":"https://schema.org",
    "@type":"FAQPage",
    "mainEntity": items.map(({q,a}) => ({
      "@type":"Question","name":q,
      "acceptedAnswer":{"@type":"Answer","text":a}
    }))
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

{/* <FAQSchema items={[
  { q: "Do you offer in-person sessions?", a: "Yes, by appointment only." },
  { q: "Are virtual sessions available?", a: "Yes, via secure video." }
]} /> */}